import { createContext, useContext } from "react";

import type { CarouselInternals } from "../types";

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const CarouselContext = createContext<CarouselInternals | null>(null);
/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const useCarouselContext = (): CarouselInternals =>
  useContext(CarouselContext) as CarouselInternals;

export { CarouselContext, useCarouselContext };
